import { Action, Method, NO_VALUE } from '../../constants.js';
export const buildSuccessAppleEmailChangePayload = (payloadParams) => {
    const { loginSource } = payloadParams;
    const trackingPayload = {
        method: Method.LINK,
        triggeringEventPlace: {
            componentId: 'candidateLoginRegisterModal',
            elementActioned: 'postAppleLoginEmailSubmit',
        },
        trackingData: {
            allowLinkBeforeView: true,
            loginSource: loginSource,
            componentState: 'postAppleLoginEmailSubmittedSuccess',
            elementAction: Action.SUCCESS,
            elementActionValue: NO_VALUE,
        },
    };
    return trackingPayload;
};
//# sourceMappingURL=buildSuccessAppleEmailChangePayload.js.map